import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { ShopDetailResponse } from '@/repositories/generated';

const response: ShopDetailResponse = {
  id: '00001',
  name: '○○○○ 渋谷店',
  externalShopId: 'shop01',
  phone: '03-1234-5678',
  status: 'AVAILABLE',
  defaultShop: false,
  shopDetailBasicInfo: {
    postalCode: '160-0022',
    prefecture: '東京都',
    municipalities: '渋谷区宇多川町三丁目 5-1',
    buildingName: '麹町ビル',
    dealerCode: '1234',
    shopStartDate: '2022-09-27T00:00:00+09:00',
    shopEndDate: '2030-09-27T00:00:00+09:00',
    companyResponse: {
      id: '010',
      name: '株式会社インフキュリオン',
    },
    createdAt: '2022-09-24T18:51:56+09:00',
    updatedAt: '2023-01-24T18:51:56+09:00',
    homepageUrl: 'http://www.○○○.com',
    latitude: 35.68914354752421,
    longitude: 139.6927675,
    externalIdUpdateAvailableFlg: true,
  },
  shopDetailQrInfo: {
    corporationId: '1111111111111111',
    brandId: '2222',
    contractStoreId: '333333',
  },
  shopDetailTransactionLimitInfo: {
    maxSettlementAmount: 10000,
  },
  shopDetailSettlementServiceInfos: [{
    walletServiceResponse: {
      id: '016',
      name: '○○Pay',
    },
    walletServiceSettlementSettingId: 1,
    settlementService: 'BALANCE_MANAGER',
    shopSettlementServiceStartDate: '2023-10-11T00:00:00+09:00',
    shopSettlementServiceEndDate: '2034-10-11T00:00:00+09:00',
    directBankFeeRatio: 1,
    prepaidSettlementFeeRatio: 2,
    prepaidChargeFeeRatio: 3,
    creditFeeRatio: 4,
    pspGmoShopId: '',
    pspGmoShopPassword: '',
  },
  {
    walletServiceResponse: {
      id: '017',
      name: '○○Pay',
    },
    walletServiceSettlementSettingId: 2,
    settlementService: 'PSP_GMO',
    shopSettlementServiceStartDate: '2023-10-11T00:00:00+09:00',
    shopSettlementServiceEndDate: '2034-10-11T00:00:00+09:00',
    directBankFeeRatio: 1,
    prepaidSettlementFeeRatio: 2,
    prepaidChargeFeeRatio: 3,
    creditFeeRatio: 4,
    pspGmoShopId: '11111',
    pspGmoShopPassword: '12345',
    pspGmoCompUsageFlg: false,
  },
  {
    walletServiceResponse: {
      id: '017',
      name: '○○Pay',
    },
    walletServiceSettlementSettingId: 2,
    settlementService: 'PSP_GMO',
    shopSettlementServiceStartDate: '2023-10-11T00:00:00+09:00',
    shopSettlementServiceEndDate: '2034-10-11T00:00:00+09:00',
    directBankFeeRatio: 1,
    prepaidSettlementFeeRatio: 2,
    prepaidChargeFeeRatio: 3,
    creditFeeRatio: 4,
    pspGmoShopId: '11111',
    pspGmoShopPassword: '12345',
    pspGmoCompUsageFlg: undefined,
  },
  {
    walletServiceResponse: {
      id: '018',
      name: '○○Pay',
    },
    walletServiceSettlementSettingId: 3,
    settlementService: 'PSP_DGFT',
    shopSettlementServiceStartDate: '2023-10-11T00:00:00+09:00',
    shopSettlementServiceEndDate: '2034-10-11T00:00:00+09:00',
    directBankFeeRatio: 1,
    prepaidSettlementFeeRatio: 2,
    prepaidChargeFeeRatio: 3,
    creditFeeRatio: 4,
    pspGmoShopId: undefined,
    pspGmoShopPassword: undefined,
    pspGmoCompUsageFlg: undefined,
  },
  {
    walletServiceResponse: {
      id: '019',
      name: '○○Pay',
    },
    walletServiceSettlementSettingId: 4,
    settlementService: 'BANK_PAY',
    shopSettlementServiceStartDate: '2023-10-11T00:00:00+09:00',
    shopSettlementServiceEndDate: '2034-10-11T00:00:00+09:00',
    directBankFeeRatio: 1,
    prepaidSettlementFeeRatio: 2,
    prepaidChargeFeeRatio: 3,
    creditFeeRatio: 4,
    pspGmoShopId: '',
    pspGmoShopPassword: '',
  },
  {
    walletServiceResponse: {
      id: '020',
      name: '○○Pay',
    },
    walletServiceSettlementSettingId: 2,
    settlementService: 'PSP_GMO',
    shopSettlementServiceStartDate: '2023-10-11T00:00:00+09:00',
    shopSettlementServiceEndDate: '2034-10-11T00:00:00+09:00',
    directBankFeeRatio: 1,
    prepaidSettlementFeeRatio: 2,
    prepaidChargeFeeRatio: 3,
    creditFeeRatio: 4,
    pspGmoShopId: '11111',
    pspGmoShopPassword: '12345',
    pspGmoCompUsageFlg: true,
  }],
  shopDetailGiftInfos: [
    {
      giftId: '1',
      giftDetailId: '1',
      giftName: '商品券A',
      giftDetailName: '【赤券】（大型店・一般店で利用可能）',
      expiresStartDate: '2023-10-11',
      expiresEndDate: '2030-10-11',
    },
    {
      giftId: '2',
      giftDetailId: '2',
      giftName: '商品券B',
      giftDetailName: '【青券】（一般店で利用可能）',
      expiresStartDate: '2021-10-11',
      expiresEndDate: '2030-10-11',
    },
    {
      giftId: '3',
      giftDetailId: '3',
      giftName: '商品券C',
      giftDetailName: '【緑券】（一般店で利用可能）',
      expiresStartDate: '2021-10-11',
      expiresEndDate: '2022-10-11',
    },
  ],
  remarks: 'テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト',
  regex: '^[0-9a-zA-Z]*$',
  shopDetailSmartCodeInfo: {
    nameKana: 'テストテンポ',
    nameRomaji: 'TESUTOTENPO',
    merchantCategoryCode: '00001',
    smartCodeStartsAt: '2023-01-01T00:00:00+09:00',
    smartCodeEndsAt: '2100-12-31T00:00:00+09:00',
  },
};

export const shopDetail = http.get(
  createMockEndpoint('/shop/:id'),
  async ({ params }) => {
    if (params.id === '000000002') {
      const nullResponse: ShopDetailResponse = {
        ...response,
        ...{
          shopDetailBasicInfo: {
            companyResponse: {
              id: '010',
              name: '株式会社インフキュリオン',
            },
            createdAt: '2022-09-24T18:51:56+09:00',
            updatedAt: '2023-01-24T18:51:56+09:00',
            externalIdUpdateAvailableFlg: true,
          },
        },
      };

      return HttpResponse.json(nullResponse, { status: 200 });
    }
    await delay(500);

    return HttpResponse.json(response, { status: 200 });
  },
);
